<header class="wasser-app-header" role="banner" aria-label="Seitenkopf">
  <app-header-component />
</header>

<main id="main" class="wasser-app-main bg-gray-50" role="main" aria-label="Hauptinhalt" tabindex="-1">
  @if (isRouting()) {
    <div class="fixed inset-0 flex items-center justify-center bg-black/20 z-50" role="status" aria-live="polite" aria-label="Seite wird geladen">
      <div class="flex items-center gap-3">
        <div class="w-8 h-8 border-4 border-gray-300 border-t-blue-500 rounded-full animate-spin"></div>
        <span class="text-gray-700">Seite wird geladen...</span>
      </div>
    </div>
  } @else {
    <div class="wasser-app-content">
      <router-outlet />
    </div>
  }
</main>

<footer class="wasser-app-footer" role="contentinfo" aria-label="Seitenende">
  <app-footer-component />
</footer>
